"use client";

// components/public/CookieConsentLazy.tsx
//
// Client-side lazy wrapper around the consent banner. The banner is fixed
// bottom-of-viewport and only relevant when no consent decision has been
// made — there is zero benefit to including its bundle in the initial
// route JS. Wrapping in next/dynamic with ssr:false:
//
//   - Removes ~2KB of CookieConsent + lucide deps from the homepage and
//     /reviews initial bundle (Lighthouse #408/410 — Total Blocking Time).
//   - Skips SSR entirely for this component, so the banner never lands in
//     the prerendered HTML and never participates in hydration on first
//     paint.
//   - The chunk fetches on idle; CookieConsent's own internal
//     requestIdleCallback then checks the consent cookie and decides
//     whether to render. Worst case visible delay: ~200ms post-FCP, which
//     is well within UX expectations for a non-blocking banner.

import dynamic from "next/dynamic";

const CookieConsentInner = dynamic(
  () => import("@/components/public/CookieConsent"),
  { ssr: false },
);

export default function CookieConsentLazy() {
  return <CookieConsentInner />;
}
